import { useAuth } from '../contexts/AuthContext'

export const useSocialSignIn = () => {
  const { loginWithGoogle, loginWithDiscord, loginWithMicrosoft, isLoading } = useAuth()

  const handleGoogleSignIn = (disabled) => {
    if (!disabled && !isLoading) {
      loginWithGoogle()
    }
  }

  const handleDiscordSignIn = (disabled) => {
    if (!disabled && !isLoading) {
      loginWithDiscord()
    }
  }

  const handleMicrosoftSignIn = (disabled) => {
    if (!disabled && !isLoading) {
      loginWithMicrosoft()
    }
  }

  return {
    isLoading,
    handleGoogleSignIn,
    handleDiscordSignIn,
    handleMicrosoftSignIn
  }
}